(function ($) {
	$(document).ready(function(){
		//search
		$('.icon-1-top-menu_search').on('click', function(){
			$('.search-block-wrap').toggleClass('active');
		});

		//left sidebar
		$('#side-menu .menu-item-has-children>a').after('<span class="arrow-in-down-wrap"><i class="arrow-in-down"></i></span>');
		$('#side-menu .menu-item-has-children li span').on('click', function (e) {
			$(this).parents('.menu-item-has-children').toggleClass('show');
			$(this).siblings('.dropdown-menu').toggleClass('show');
			e.preventDefault();
			e.stopPropagation();
		});

		//Google Website Translator
		$('.wpml-ls-sub-menu').append($('.gwt-wrap'));


		//stop and play animation for slider on main page
		$('.wrap-pause-btn').on('click', function(){
			if($('.pause-js').hasClass('active')){
				$('#index-slider').carousel();
			}else{
				$('#index-slider').carousel('pause');
			}
			$('.pause-js').toggleClass('active');
		});

	})
})(jQuery);
